module.exports = __webpack_public_path__ + "static/media/banner_news_marcar_como_lido.e6241a84.png";